// Route → lazy chunk loaders. Shared with App.js so a prefetch warms the same chunk React.lazy will use.
export const LOADERS = {
  "/login": () => import("@/pages/Login"),
  "/forgot-password": () => import("@/pages/ForgotPassword"),
  "/reset-password": () => import("@/pages/ResetPassword"),
  "/register": () => import("@/pages/Register"),
  "/dashboard": () => import("@/pages/Dashboard"),
  "/jobs/new": () => import("@/pages/PostJob"),
  "/jobs/:id": () => import("@/pages/JobDetail"),
  "/availability/new": () => import("@/pages/PostAvailability"),
  "/contractors/:id": () => import("@/pages/ContractorProfile"),
  "/bookings": () => import("@/pages/Work"),
  "/requests": () => import("@/pages/Work"),
  "/profile": () => import("@/pages/Profile"),
  "/settings": () => import("@/pages/Settings"),
  "/secure-account": () => import("@/pages/SecureAccount"),
  "/admin": () => import("@/pages/Admin"),
  "/setup": () => import("@/pages/Setup"),
  "/how-it-works": () => import("@/pages/HowItWorks"),
  "/rate-guide": () => import("@/pages/RateGuide"),
  "/statements": () => import("@/pages/Statements"),
  "/invoices/:id": () => import("@/pages/Invoice"),
  "/payment/success": () => import("@/pages/PaymentSuccess"),
  "/payment/cancel": () => import("@/pages/PaymentCancel"),
  "*": () => import("@/pages/NotFound"),
};

const done = new Set();

function keyFor(path) {
  const p = (path || "").split("?")[0];
  if (LOADERS[p]) return p;
  if (/^\/jobs\/[^/]+$/.test(p)) return "/jobs/:id";
  if (/^\/contractors\/[^/]+$/.test(p)) return "/contractors/:id";
  if (/^\/invoices\/[^/]+$/.test(p)) return "/invoices/:id";
  return null;
}

export function prefetchRoute(path) {
  const k = keyFor(path);
  if (!k || done.has(k)) return;
  done.add(k);
  LOADERS[k]().catch(() => done.delete(k));
}

export function prefetchWhenIdle(paths) {
  const run = () => paths.forEach(prefetchRoute);
  if ("requestIdleCallback" in window) window.requestIdleCallback(run, { timeout: 3000 });
  else setTimeout(run, 1500);
}
